import React, { Component } from "react";
import "./style.css";
import "../TransactionDetails/style.css";
import {
  Table,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  FormGroup,
  Input,
} from "reactstrap";
import DatePicker from "react-date-picker";
import { connect } from "react-redux";
import moment from "moment";
import { Line } from "react-chartjs-2";

import {
  generateRandomKey,
  isNetworkRequestFailedError,
} from "../../config/helpers";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import authAction from "../../redux/auth/action";
import fundPricesAction from "../../redux/fundPrices/action";
import api from "../../config/api";
import editIcon from "../../assets/icons/edit.png";
import CustomButton from "../../component/CustomButton/CustomButton";
import PageHead from "../../component/pageHead/PageHead";

class FundPriceByDateRange extends Component {
  state = {
    from: new Date(),
    to: new Date(),
    mode: "graph",
    fundName: "",
    fundId: "",
    fundPrice: null,
    fundHistoryPrice: null,
    suggestedData: [],
    isLoading: false,
    showCalender: true,
  };

  fetchContributions = () => {};

  handlePriceInputChange = (e) => {
    const {
      allFunds,
      setFundByDate,
      fundHistoryPrice,
      fundPrice,
      from,
      to,
      fundId,
    } = this.props;
    const value = e.target.value;
    let filteredArr = [];

    const reduxPayload = {
      fundName: value,
      fundHistoryPrice,
      fundPrice,
      input: { from, to },
      fundId,
    };

    if (value) {
      filteredArr = allFunds.filter((e) =>
        e.FUND_NAME.toLowerCase().includes(value.toLowerCase())
      );
    }

    setFundByDate(reduxPayload);
    this.setState({ fundName: e.target.value, suggestedData: filteredArr });
  };

  // handleSuggestionClick = suggestion => {
  //   const { setFundByDate, fundHistoryPrice, fundPrice, from, to } = this.props;

  //   const reduxPayload = {
  //     fundName: suggestion.FUND_NAME,
  //     fundHistoryPrice,
  //     fundPrice,
  //     input: { from, to },
  //     fundId: suggestion.FUND_ID
  //   };

  //   setFundByDate(reduxPayload);

  //   this.setState({
  //     fundName: suggestion.FUND_NAME,
  //     fundId: suggestion.FUND_ID
  //   });
  // };

  onSelectChange = (e) => {
    const { allFunds } = this.props;
    const selectedId = parseInt(e.target.value);
    const selectedFund =
      allFunds.find((item) => item.FUND_ID === selectedId) || {};

    const { setFundByDate, fundHistoryPrice, fundPrice, from, to } = this.props;

    const reduxPayload = {
      fundName: selectedFund.FUND_NAME,
      fundHistoryPrice,
      fundPrice,
      input: { from, to },
      fundId: selectedFund.FUND_ID,
    };

    setFundByDate(reduxPayload);

    this.setState({
      fundName: selectedFund.FUND_NAME,
      fundId: selectedFund.FUND_ID,
    });
  };

  fetchFundPrice = async () => {
    const {
      setAlertMessage,
      user,
      setFundByDate,
      fundHistoryPrice,
      from,
      to,
      fundName,
      fundId,
    } = this.props;

    try {
      if (!fundId) throw new Error("Please select Fund Name");

      this.setState({ isLoading: true });

      const response = await api.fetchCurrentPrice({ fundId }, user.token);

      const reduxPayload = {
        fundName,
        fundHistoryPrice,
        fundPrice: response.data.result,
        input: { from, to },
        fundId,
      };

      setFundByDate(reduxPayload);

      this.setState({ fundPrice: response.data.result });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchFundPrice : null,
      });
    }

    this.setState({ isLoading: false });
  };

  getPriceDateRange = async (type, newFrom) => {
    const {
      setAlertMessage,
      user,
      setFundByDate,
      fundName,
      fundPrice,
      fundId,
      from,
      to,
    } = this.props;

    if (newFrom !== "fixed" && (!from || !to)) return;

    let startDate = from && moment(from).format("YYYY-MMMM-DD");

    let endDate = to && moment(to).format("YYYY-MMMM-DD");

    try {
      if (newFrom !== "fixed" && moment(to).isBefore(newFrom)) {
        throw new Error("From date can not be higher than to");
      }

      if (type === "this_year") {
        startDate = moment().startOf("year").format("YYYY-MMMM-DD");
        endDate = moment().format("YYYY-MMMM-DD");
        this.setState({ from: new Date(startDate), to: new Date(endDate) });
      }

      if (type === "last_year") {
        startDate = moment()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MMMM-DD");
        endDate = moment()
          .subtract(1, "year")
          .endOf("year")
          .format("YYYY-MMMM-DD");
        this.setState({ from: new Date(startDate), to: new Date(endDate) });
      }

      if (type === "quarter") {
        startDate = moment()
          .subtract(1, "quarter")
          .startOf("quarter")
          .format("YYYY-MMMM-DD");
        endDate = moment().format("YYYY-MMMM-DD");
        this.setState({ from: new Date(startDate), to: new Date(endDate) });
      }

      this.setState({ isLoading: true });
      if (!fundId) throw new Error("Please input required Fund Name");

      const payload = {
        startDate,
        endDate,
        fundId,
      };

      const response = await api.fetchPriceByDateRange(payload, user.token);

      // let formatedStartDate = moment(from).format("MMMM-DD-YYYY");
      // let formatedEndDate = moment(to).format("MMMM-DD-YYYY");

      const reduxPayload = {
        fundName,
        fundHistoryPrice: response.data.result,
        fundPrice,
        input: {
          from: new Date(from),
          to: new Date(to),
        },
        fundId,
      };

      setFundByDate(reduxPayload);

      this.setState({ fundHistoryPrice: response.data.result });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? () => this.getPriceDateRange(type, newFrom)
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  handlePickerChange = (key, value) => {
    let {
      setFundByDate,
      fundName,
      fundPrice,
      fundHistoryPrice,
      from,
      to,
      fundId,
    } = this.props;

    if (key === "from" && moment(to).isBefore(value)) {
      this.setState({ showCalender: false }, () => {
        this.getPriceDateRange(null, value);
        this.setState({ showCalender: true });
      });
      return;
    }

    const reduxPayload = {
      fundName,
      fundHistoryPrice,
      fundPrice,
      input: { from, to },
      fundId,
    };

    reduxPayload.input[key] = value;
    // reduxPayload.input.to = to;

    setFundByDate(reduxPayload);

    this.setState({ [key]: value, to }, () =>
      this.getPriceDateRange(null, value)
    );
  };

  render() {
    const { mode, isLoading } = this.state;
    const { from, to, fundPrice, fundHistoryPrice, allFunds, fundId } =
      this.props;

    return (
      <div>
        <div className="current-fund-price-container">
          <Row className="flex1">
            <Col lg={9} md={9} sm={6} className="p-0 d-flex align-items-end">
              <FormGroup className="flex1">
                <Input
                  className="margin-y-10"
                  type="select"
                  name="select"
                  id="exampleSelect"
                  value={fundId || "placeholder"}
                  onChange={this.onSelectChange}
                >
                  <option value="placeholder" disabled>
                    Select Fund Name
                  </option>
                  {allFunds.map((item) => (
                    <option key={Math.random().toString()} value={item.FUND_ID}>
                      {item.FUND_NAME}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col lg={3} md={3} sm={6} className="mx-auto pl-0 pl-sm-3 pr-0">
              <CustomButton
                onClick={this.fetchFundPrice}
                buttonText="Search"
                buttonContainerClasses={"margin-y-10"}
                buttonStyle={{ width: "100%" }}
              />
            </Col>
          </Row>
        </div>
        {fundPrice && (
          <div>
            <PageHead
              title={fundPrice.FundName}
              containerStyles={{ width: "100%" }}
            />

            <ListGroup className="mt-2">
              <ListGroupItem className="transaction-details-picker-container">
                <p className="pr-1">Time Period</p>
                <div className="transaction-details-picker">
                  {this.state.showCalender && (
                    <DatePicker
                      calendarIcon={<CalenderIcon />}
                      calendarClassName="transaction-details-calender-main-container"
                      className="transaction-details-calender-field mx-1"
                      value={from}
                      format="M/d/yyyy"
                      onChange={(value) =>
                        this.handlePickerChange("from", value)
                      }
                    />
                  )}
                  {this.state.showCalender && (
                    <DatePicker
                      calendarIcon={<CalenderIcon />}
                      calendarClassName="transaction-details-calender-main-container"
                      className="transaction-details-calender-field mr-1"
                      value={to}
                      minDate={from && new Date(moment(from))}
                      format="M/d/yyyy"
                      onChange={(value) => this.handlePickerChange("to", value)}
                    />
                  )}
                </div>
                <div className="transaction-details-calender-btns-container">
                  <button
                    className="transaction-details-calender-btn"
                    onClick={this.getPriceDateRange.bind(
                      this,
                      "this_year",
                      "fixed"
                    )}
                  >
                    This Year
                  </button>
                  <button
                    className="transaction-details-calender-btn mx-1"
                    onClick={this.getPriceDateRange.bind(
                      this,
                      "last_year",
                      "fixed"
                    )}
                  >
                    Last Year
                  </button>
                  <button
                    className="transaction-details-calender-btn"
                    onClick={this.getPriceDateRange.bind(
                      this,
                      "quarter",
                      "fixed"
                    )}
                  >
                    Last Quarter
                  </button>
                </div>
              </ListGroupItem>
              {fundHistoryPrice && (
                <ListGroupItem className="p-0 date-range-btn-pill-container my-2 flex-column">
                  <div className="p-1 px-4  d-flex justify-content-end w-100 my-1 mb-2">
                    <div>
                      <button
                        onClick={() => this.setState({ mode: "graph" })}
                        className={`date-range-btn-pill ${
                          mode === "graph" && "date-range-btn-pill-active"
                        }`}
                      >
                        Graph
                      </button>
                      <button
                        onClick={() => this.setState({ mode: "table" })}
                        className={`date-range-btn-pill ${
                          mode === "table" && "date-range-btn-pill-active"
                        }`}
                      >
                        Data
                      </button>
                    </div>
                  </div>
                  {fundHistoryPrice ? (
                    mode === "table" ? (
                      <PriceTable data={fundHistoryPrice} />
                    ) : (
                      <PriceGraph data={fundHistoryPrice} />
                    )
                  ) : null}
                </ListGroupItem>
              )}
            </ListGroup>
          </div>
        )}
        {isLoading && <CustomLoader />}
      </div>
    );
  }
}

function CalenderIcon() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img alt="edit-icon" src={editIcon} width="20px" />
    </div>
  );
}

function PriceTable({ data }) {
  return (
    data && (
      <Table className="fund-price-date-range-table" bordered size="sm">
        <thead>
          <tr>
            <th className="py-2">Value Date</th>
            <th className="py-2">Unit Price</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={generateRandomKey()}>
              <td style={{ color: "#1c4199" }}>
                {moment(item.ValueDate).format("MMMM DD, YYYY")}
              </td>
              <td className="text-right">{item.UnitPrice}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  );
}

function PriceGraph({ data: fundHistory }) {
  const points = [];
  const gap = [];

  if (!fundHistory) return <div />;
  fundHistory.forEach((item) => {
    points.unshift(item.UnitPrice);
    gap.unshift(moment(item.ValueDate).format("MMMM DD"));
  });

  const data = {
    labels: gap,
    datasets: [
      {
        fill: true,
        lineTension: 0.1,
        backgroundColor: "#d6e8f5",
        borderColor: "#4a7df5",
        borderCapStyle: "round",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "round",
        pointBorderColor: "#4a7df5",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(75,192,192,1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 1,
        data: points,
      },
    ],
  };
  return (
    <Line
      options={{
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                maxTicksLimit: 14,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                maxTicksLimit: 14,
              },
            },
          ],
        },
      }}
      data={data}
    />
  );
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  from: state.fundPrices.fundByDate.input.from,
  to: state.fundPrices.fundByDate.input.to,
  fundName: state.fundPrices.fundByDate.fundName,
  fundPrice: state.fundPrices.fundByDate.fundPrice,
  fundHistoryPrice: state.fundPrices.fundByDate.fundHistoryPrice,
  fundId: state.fundPrices.fundByDate.fundId,
});

const mapDispatchToProps = {
  setAlertMessage: authAction.setAlertMessage,
  setFundByDate: fundPricesAction.setFundByDate,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundPriceByDateRange);
